/**
 * @export
 */
class EventEmitter {
  constructor() {
    this._eventHandlers = {}
  }

  /**
   * @param {string} eventName
   * @param {Function} handler
   */
  addEvent(eventName, handler) {
    if (!this._eventHandlers[eventName]) {
      this._eventHandlers[eventName] = []
    }
    this._eventHandlers[eventName].push(handler)
  }

  /**
   * @param {string} eventName
   * @param {Function} handler
   */
  deleteEvent(eventName, handler) {
    const handlers = this._eventHandlers && this._eventHandlers[eventName]
    if (handlers) {
      const filteredHandlers = handlers.filter(eventHandler => eventHandler == handler)
      this._eventHandlers[eventName] = filteredHandlers;
    }
  }

  /**
   * 登録されているイベントの一括削除
   */
  deleteAllEvents() {
    this._eventHandlers = {}
  }

  /**
   * @param {string} eventName
   * @param  {...any} args
   */
  trigger(eventName, ...args) {
    const handlers = this._eventHandlers && this._eventHandlers[eventName]
    if (handlers) {
      handlers.forEach(handler => handler.apply(this, args))
    }
  }
}

export default EventEmitter
